import * as React from "react";
import { NavItem } from "./incident.style";
import gener8logo from "../../assets/images/gener8_logo-02.png";
import { AiOutlineClose } from "react-icons/ai";
import { stages } from "../../utils/helpers/incidentFormTabs";
import { HiOutlineUsers } from "react-icons/hi";
import { CgAttachment } from "react-icons/cg";
import { useLocation } from "react-router-dom";
import { doesUrlEndWith } from "./methods";
import { TabOptions } from "../../types/fieldInstance.interface";

interface IncidentSideBarProps {
  onLogoClick: () => void;
  onLinkClick: (path: string, label: string) => void;
  tabState: any; // Ideally, define a more specific type
  onSelectItem: () => void;
  showApprovalsSection: boolean;
}

const IncidentSideBar: React.FC<IncidentSideBarProps> = ({
  onLogoClick,
  onLinkClick,
  tabState,
  onSelectItem,
  showApprovalsSection,
}) => {
  const location = useLocation();

  function shouldRenderCheck(
    stage: { label: string; path: string },
    isActive: boolean
  ): boolean {
    if (!tabState) {
      return false;
    }
    if (!isActive) {
      return tabState[stage.label]?.visited
        ? tabState[stage.label]?.isFormValid
        : tabState[stage.label]?.isFormValid &&
            !!tabState[stage.label]?.isFormDirty;
    }
    return tabState[stage.label]?.isFormValid;
  }

  function shouldRenderLink(item: {
    label: string;
    path: string;
    renderAfterSubmit?: boolean;
    hideInSection?: boolean;
  }): boolean {
    if (item?.renderAfterSubmit || item?.hideInSection) {
      return showApprovalsSection;
    }
    return !item?.hideInSection;
  }

  const renderStagePrefix = (stage: any, index: number, isActive: boolean) => {
    if (stage.label === TabOptions.Approvals) {
      return <HiOutlineUsers size={23} />;
    } else if (stage.label === TabOptions.Attachments) {
      return <CgAttachment size={23} />;
    } else {
      return shouldRenderCheck(stage, isActive) ? (
        <span className="mr-3">
          <img src="../../assets/images/Checkbox.png" alt="" />
        </span>
      ) : (
        <span className="mr-3 font-bold">0{index + 1}</span>
      );
    }
  };

  const handleStageClick = (stage: any) => {
    onLinkClick(stage.path, stage.label);
    onSelectItem();
  };

  const renderNavItem = (stage: any, index: number) => {
    if (!shouldRenderLink(stage)) return null;
    const isActive = doesUrlEndWith(location.pathname, stage.path);

    return (
      <div
        key={stage.path}
        onClick={() => handleStageClick(stage)}
        onKeyDown={() => {}}
      >
        <NavItem active={isActive} data-testid={`sidebar-item-${stage.label}`}>
          {renderStagePrefix(stage, index, isActive)}
          {stage.label}
        </NavItem>
      </div>
    );
  };

  return (
    <div className="bg-sidebar-bg text-white flex h-screen flex-col">
      <div className="p-4">
        <div className="flex items-center justify-between">
          <div
            className="flex cursor-pointer items-center"
            role="link"
            onClick={onLogoClick}
          >
            <img
              src="../../assets/images/mG_logo_light.svg"
              alt="mG Logo"
              className="h-8 w-8"
            />
            <img src={gener8logo} alt="Gener8 Logo" className="ml-3 w-24" />
          </div>
          <div className="md:hidden">
            <AiOutlineClose
              onClick={() => onSelectItem()}
              className="text-white text-2xl"
            />
          </div>
        </div>
      </div>

      <nav className="mt-8 flex-grow overflow-y-auto">
        {stages.filter((stage) => !stage.hideInSection).map(renderNavItem)}
      </nav>

      <div className="mt-auto">
        <div className="p-4">
          <div className="mb-3 text-xs text-gray-400">
            DOCUMENTS/ATTACHMENTS
          </div>
          {stages
            .filter(
              (stage) =>
                stage.hideInSection && stage.label !== TabOptions.Approvals
            )
            .map(renderNavItem)}
        </div>
      </div>

      {showApprovalsSection && (
        <div className="p-4">
          <div className="mb-3 text-xs text-gray-400">ADMIN ONLY</div>
          {stages
            .filter(
              (stage) =>
                stage.hideInSection && stage.label !== TabOptions.Attachments
            )
            .map(renderNavItem)}
        </div>
      )}
    </div>
  );
};

export default IncidentSideBar;
